export const RELEASE_TYPES = ["Single", "EP", "Album"];

export const GENRES = ["Latin Pop", "Reggaeton", "Urbano Latino", "Trap Latino", "Regional Mexicano", "Corridos Tumbados", "Banda",
  "Salsa", "Bachata", "Cumbia", "Rock en Español", "Pop", "Hip-Hop/Rap", "R&B", "Electrónica", "Dembow", "Christian/Gospel",
  "Alternativa", "Indie", "Balada", "Tropical", "Jazz", "Clásica", "Otro"];

export const LANGUAGES = [["es", "Español"], ["en", "Inglés"], ["pt", "Portugués"], ["fr", "Francés"], ["it", "Italiano"], ["zxx", "Instrumental"]];

import DSPS from "./dsps.json";

export const STORES = DSPS.map((d) => d.name);
export const DSP_ID_TO_NAME = Object.fromEntries(DSPS.map((d) => [d.id, d.name]));
export const POPULAR_STORES = ["Spotify", "Apple Music", "iTunes", "Amazon Music", "YouTube Music", "YouTube Content ID", "Deezer", "TikTok", "Facebookmusic", "Facebook Fingerprinting", "Tidal", "Pandora", "iHeartRadio", "Anghami", "Audiomack", "Beatport", "iMusica"];

export const REGIONS = {
  "América Latina": ["MX", "CO", "AR", "CL", "PE", "VE", "EC", "GT", "DO", "PR", "CR", "PA", "UY", "BO", "PY", "HN", "SV", "NI", "CU", "BR"],
  "Norteamérica": ["US", "CA"],
  "Europa": ["ES", "GB", "DE", "FR", "IT", "PT", "NL", "SE", "NO", "PL", "CH", "BE", "IE"],
  "Asia-Pacífico": ["JP", "KR", "AU", "NZ", "IN", "PH", "ID", "SG"],
  "África & Medio Oriente": ["ZA", "NG", "EG", "MA", "AE", "SA", "TR", "IL"],
};

export const ARTIST_ROLES = ["Primary Artist", "Featured Artist", "Remixer"];
export const CONTRIBUTOR_ROLES = ["Composer", "Lyricist", "Producer", "Co-Producer", "Mixing Engineer", "Mastering Engineer",
  "Recording Engineer", "Arranger", "Publisher", "Songwriter"];

export const STATUS = {
  draft: { label: "Borrador", cls: "bg-slate-500/15 text-slate-600 dark:text-slate-300 border-slate-400/30" },
  queued: { label: "En cola", cls: "bg-blue-500/15 text-blue-600 dark:text-blue-300 border-blue-400/30" },
  running: { label: "Ejecutando", cls: "bg-blue-500/15 text-blue-600 dark:text-blue-300 border-blue-400/30" },
  uploading: { label: "Subiendo", cls: "bg-blue-500/15 text-blue-600 dark:text-blue-300 border-blue-400/30" },
  waiting_2fa: { label: "Esperando 2FA", cls: "bg-amber-500/15 text-amber-600 dark:text-amber-300 border-amber-400/30" },
  completed: { label: "Enviado a distribución", cls: "bg-cyan-500/15 text-cyan-600 dark:text-cyan-300 border-cyan-400/30" },
  approved: { label: "Aprobado", cls: "bg-blue-600/15 text-blue-700 dark:text-blue-300 border-blue-500/40" },
  failed: { label: "Fallido", cls: "bg-red-500/15 text-red-600 dark:text-red-300 border-red-400/30" },
  cancelled: { label: "Cancelado", cls: "bg-slate-500/15 text-slate-600 dark:text-slate-300 border-slate-400/30" },
};

// Los artistas no deben ver nada relacionado con Downtown / bot: etiquetas neutrales
export const ARTIST_STATUS_OVERRIDE = {
  queued: { label: "En proceso", cls: STATUS.queued.cls },
  running: { label: "En proceso", cls: STATUS.queued.cls },
  uploading: { label: "En proceso", cls: STATUS.queued.cls },
  waiting_2fa: { label: "En proceso", cls: STATUS.queued.cls },
  failed: { label: "En revisión", cls: "bg-amber-500/15 text-amber-600 dark:text-amber-300 border-amber-400/30" },
};

export const STORE_STATE = {
  published: { label: "Aprobado", cls: "text-blue-500 dark:text-blue-300" },
  pending: { label: "Pendiente", cls: "text-amber-500" },
  in_progress: { label: "En progreso", cls: "text-blue-400" },
  rejected: { label: "Rechazado", cls: "text-red-500" },
  removed: { label: "Retirado", cls: "text-muted-foreground" },
  unknown: { label: "Sin datos", cls: "text-muted-foreground" },
};

export const ROLE_LABEL = { admin: "Administrador", manager: "A&R / Manager", artist: "Artista" };
